module.exports = __webpack_public_path__ + "img/image_frame.47c001e5.png";